import { checkNotEmpty } from '~h/validators';

export const companyFormInputs = [
  {
    name: 'companyName',
    label: 'Наименование компании',
    type: 'company',
    required: true,
    classes: null,
    error: false,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'inn',
    label: 'ИНН',
    type: 'company',
    required: true,
    classes: null,
    error: false,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'kpp',
    label: 'КПП',
    type: 'text',
    required: true,
    classes: null,
    error: false,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'city',
    label: 'Город',
    type: 'city',
    required: true,
    classes: null,
    error: false,
    validator: checkNotEmpty,
    renderBlock: 2,
  },
  {
    name: 'address',
    label: 'Юридический адрес',
    type: 'address',
    required: true,
    classes: 'inp--lg',
    error: false,
    isForPaidEvents: false,
    validator: checkNotEmpty,
    renderBlock: 2,
  },
  {
    name: 'factAddress',
    label: 'Фактический адрес',
    type: 'address',
    required: true,
    classes: 'inp--lg',
    error: false,
    validator: checkNotEmpty,
    renderBlock: 3,
  },
];